import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [설정 > applog] Applog의 리스트를 조회 한다
   * @author lsy
   * @param  {Object} params [description]
   * @return {Map} [description]
   */
  getApplogList(params) {
    return axios.get(`${baseUrl}/settings/applog-setting/get-applog-group.do`, { params });
  },
  /**
   * 로그 그룹 추가
   * @author lsy
   * @param  {[type]} params [description]
   */
  addApplogGroup(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/add-applog-group.do`, params);
  },
  /**
   * 그룹 내 로그 정보 조회
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]} [description]
   */
  getApplogSet(params) {
    return axios.get(`${baseUrl}/settings/applog-setting/get-applog-set.do`, { params });
  },
  /**
   * 로그 그룹 내 로그 추가
   * @author lsy
   * @param  {[type]} params [description]
   */
  addApplogInGroup(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/add-applog-set.do`, params);
  },
  /**
   * 로그 그룹 내 로그 수정
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateApplogInGroup(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/update-applog-set.do`, params);
  },
  /**
   * 그룹 안에 로그 제거
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteApplogInGroup(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/delete-applog-set.do`, params);
  },
  /**
   * 그룹 제거
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteApplogGroup(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/delete-applog-group.do`, params);
  },
  /**
   * 그룹 수정
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateApplogGroup(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/update-applog-group.do`, params);
  },
  /**
   * 필터링 설정 탭에서 사용할 정보를 가져온다
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApplogFilterList(params) {
    return axios.get(`${baseUrl}/settings/applog-setting/get-applog-filter.do`, { params });
  },
  /**
   * 보유한 설정 로그의 이름을 가져온다.
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApplogName(params) {
    return axios.get(`${baseUrl}/settings/applog-setting/get-applog-name.do`, { params });
  },
  /**
   * 필터 추가
   * @author lsy
   * @param  {[type]} params [description]
   */
  addApplogFilter(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/add-applog-filter.do`, params);
  },
  /**
   * 필터 조건 수정
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateApplogFilter(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/update-applog-filter.do`, params);
  },
  /**
   * 필터 삭제
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteApplogFilter(params) {
    return axios.post(`${baseUrl}/settings/applog-setting/delete-applog-filter.do`, params);
  },
  /**
   * 그룹 저장에 사용할 트리 정보를 가져온다.
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getGrpTree(params) {
    return axios.get(`${baseUrl}/settings/applog-setting/get-grp-tree.do`, { params });
  },
  /**
   * 로그 그룹 저장
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  saveApplogGroup(queryString, params) {
    return axios.post(`${baseUrl}/settings/applog-setting/save-applog-group.do?${queryString}`, params);
  },
  /**
   * 필터 그룹 저장
   * @author lsy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  saveApplogFilterGroup(queryString, params) {
    return axios.post(`${baseUrl}/settings/applog-setting/save-applog-filter-group.do?${queryString}`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/app-log-setting.js